<template>
  <v-card class="pa-2" flat>
    <v-card-title> Administradores </v-card-title>
    <v-card-text>
      <v-form
        ref="formRef"
        v-model="formValid"
        @update:model-value="emitValidity"
      >
        <v-row>
          <v-col cols="12">
            <v-row v-for="(_, i) in form.admin_emails" :key="i" no-gutters>
              <v-col>
                <v-text-field
                  :rules="[validationRules.required, validationRules.email]"
                  v-model="form.admin_emails[i].email"
                  label="Email"
                />
              </v-col>
              <v-col cols="auto" class="d-flex align-center" v-if="i !== 0">
                <v-btn icon size="small" @click="remove(form.admin_emails[i])">
                  <v-icon :icon="mdiDelete" />
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn
                  size="small"
                  color="primary"
                  @click="addMore"
                  :disabled="!canAddMoreUsers"
                  >Adicionar mais</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { ref, computed } from "vue";
import { mdiDelete } from "@mdi/js";
import { validationRules } from "@/utils/validation";

const props = defineProps({
  form: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["errors"]);

const formRef = ref(null);
const formValid = ref(false);

const canAddMoreUsers = computed(() => {
  return props.form.admin_emails.length < 5;
});

const emitValidity = (valid) => {
  emit("errors", !valid);
};

const validate = async () => {
  const { valid } = await formRef.value.validate();
  emit("errors", !valid);
  return valid;
};

defineExpose({ validate });

const addMore = () => {
  if (canAddMoreUsers.value) {
    props.form.admin_emails.push({
      email: "",
    });
  }
};

const remove = (user) => {
  props.form.admin_emails = props.form.admin_emails.filter((u) => u !== user);
};
</script>
